module.exports = __webpack_public_path__ + "img/do.b7a28392.svg";